import { Form } from 'react-router-dom'
import { getStripePriceAmountAndCurrency } from '../helpers/localizeStripePrice'
import { Plan, StripePrice } from '../types'
import Button from './Button'

interface Props {
  buttonClassName?: string
  buttonTitle: string
  currency: string
  isSubmitting: boolean
  plan: Plan
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  stripePriceFull: StripePrice | undefined
  trialPeriodDays?: number
}

export default function SubscriptionForm({
  buttonClassName = '',
  buttonTitle,
  currency,
  isSubmitting,
  plan,
  priceId,
  setIsSubmitting,
  stripePriceFull,
  trialPeriodDays,
}: Props) {
  const handleClick = () => {
    setIsSubmitting(true)
  }

  const fullPrice = stripePriceFull
    ? getStripePriceAmountAndCurrency({
        stripePrice: stripePriceFull,
        userCurrency: currency,
      }).stripePriceAmountInCents
    : undefined

  return (
    <Form onSubmit={handleClick} method="post">
      <input type="hidden" name="currency" value={currency} />
      <input type="hidden" name="fullPrice" value={fullPrice} />
      <input type="hidden" name="plan" value={plan} />
      <input type="hidden" name="priceId" value={priceId} />
      {trialPeriodDays && (
        <input type="hidden" name="trialPeriodDays" value={trialPeriodDays} />
      )}

      <Button
        className={buttonClassName}
        disabled={isSubmitting}
        title={buttonTitle}
        type="submit"
      />
    </Form>
  )
}
